import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    userList: [],
    currentUser: null,
    currentUserId: null,
    error: null,
    fetching: false,
    passwordStatus: null,
    hasChanged: false,
    validationMessageList: [],
}


export default handleActions({

    [type.FIND_ALL_USER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_ALL_USER_SUCCESS]: (state, action) => {
        const { userList } = action.payload
        return {
            ...state,
            fetching: false,
            userList,
        }
    },
    [type.FIND_ALL_USER_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CREATE_EMPLOYEE]: (state, action) => {
        return {
            ...state,
            currentUser: {
                firstName: '',
                lastName: '',
                employee: {},
                roleList: [],
                visibleWidgetList: [],
            },
            error: null,
        }
    },
    [type.CREATE_EXTERNAL_USER]: (state, action) => {
        return {
            ...state,
            currentUser: {
                firstName: '',
                lastName: '',
                externalUser: {
                    roleList: [],
                    visibleWidgetList: [],
                },
                roleList: [],
                visibleWidgetList: [],
            },
            error: null,
        }
    },

    [type.CHANGE_CURRENT_USER_ID]: (state, action) => {
        const { currentUserId } = action.payload
        const currentUser = state.userList.find(user => {
            return user.id === currentUserId
        })
        return {
            ...state,
            currentUserId,
            passwordStatus: null,
            currentUser,
            error: null,
        }
    },
    [type.CHANGE_USER]: (state, action) => {
        const { name, value } = action.payload

        return state.currentUser.employee ? {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                [name]: value,
                employee: {
                    ...state.currentUser.employee,
                    [name]: value,
                },
            },
        } : {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                [name]: value,
                externalUser: {
                    ...state.currentUser.externalUser,
                    [name]: value,
                },
            },
        }
    },
    [type.CHANGE_EXTERNAL_USER]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                externalUser: {
                    ...state.currentUser.externalUser,
                    [name]: value,
                },
            },
        }
    },
    [type.TOGGLE_ROLE]: (state, action) => {
        const { role, active } = action.payload
        const visibleWidgetListManuallyRemoved = []
        const visibleWidgetListManuallyAdded = []
        if (!state.currentUser.visibleWidgetListManuallyRemoved) {
            state.currentUser.visibleWidgetListManuallyRemoved = visibleWidgetListManuallyRemoved
        }
        if (!state.currentUser.visibleWidgetListManuallyAdded) {
            state.currentUser.visibleWidgetListManuallyAdded = visibleWidgetListManuallyAdded
        }
        const roleList = !active ? state.currentUser.roleList.filter(roleName => roleName !== role) : [
            ...state.currentUser.roleList,
            role,
        ]
        const visibleWidgetSet = new Set()
        roleList.forEach((role) => {
            const widgetsForRole = state.roleList.find(roleObject => {
                return roleObject.role === role
            })
            if (widgetsForRole) {
                widgetsForRole.widgetList.forEach((widgetId) => visibleWidgetSet.add(widgetId))
            }
        })
        state.currentUser.visibleWidgetListManuallyAdded.forEach((widgetId) => visibleWidgetSet.add(widgetId))
        state.currentUser.visibleWidgetListManuallyRemoved.forEach((widgetId) => {
            if (visibleWidgetSet.has(widgetId)) {
                visibleWidgetSet.delete(widgetId)
            }
        })

        const visibleWidgetList = [...visibleWidgetSet]

        return state.currentUser.employee ? {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                roleList,
                visibleWidgetList,
            },
        } : {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                roleList,
                visibleWidgetList,
                externalUser: {
                    ...state.currentUser.externalUser,
                    roleList,
                    visibleWidgetList,
                },
            },

        }
    },
    [type.TOGGLE_WIDGET_ACCESS]: (state, action) => {
        const { widgetId, active } = action.payload
        let visibleWidgetListManuallyRemoved = []
        let visibleWidgetListManuallyAdded = []
        if (!state.currentUser.visibleWidgetListManuallyRemoved) {
            state.currentUser.visibleWidgetListManuallyRemoved = visibleWidgetListManuallyRemoved
        }
        if (!state.currentUser.visibleWidgetListManuallyAdded) {
            state.currentUser.visibleWidgetListManuallyAdded = visibleWidgetListManuallyAdded
        }
        if (active) {
            visibleWidgetListManuallyRemoved = state.currentUser.visibleWidgetListManuallyRemoved.filter(currentWidgetId => currentWidgetId !== widgetId)
            visibleWidgetListManuallyAdded = [
                ...state.currentUser.visibleWidgetListManuallyAdded,
                widgetId,
            ]
        } else {
            visibleWidgetListManuallyAdded = state.currentUser.visibleWidgetListManuallyAdded.filter(currentWidgetId => currentWidgetId !== widgetId)
            visibleWidgetListManuallyRemoved = [
                ...state.currentUser.visibleWidgetListManuallyRemoved,
                widgetId,
            ]
        }
        const visibleWidgetList = !active ? state.currentUser.visibleWidgetList.filter(currentWidgetId => currentWidgetId !== widgetId) : [
            ...state.currentUser.visibleWidgetList,
            widgetId,
        ]
        return state.currentUser.employee ? {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                visibleWidgetList,
                visibleWidgetListManuallyAdded,
                visibleWidgetListManuallyRemoved,
            },
        } : {
            ...state,
            hasChanged: true,
            currentUser: {
                ...state.currentUser,
                visibleWidgetList,
                visibleWidgetListManuallyAdded,
                visibleWidgetListManuallyRemoved,
                externalUser: {
                    ...state.currentUser.externalUser,
                    visibleWidgetList,
                    visibleWidgetListManuallyAdded,
                    visibleWidgetListManuallyRemoved,
                },
            },
        }
    },
    [type.SAVE_USER_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_USER_SUCCESS]: (state, action) => {
        const { currentUser } = action.payload
        return {
            ...state,
            fetching: false,
            hasChanged: false,
            currentUser,
        }
    },
    [type.SAVE_USER_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.GENERATE_NEW_PASSWORD_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            passwordStatus: 'processing',
        }
    },
    [type.GENERATE_NEW_PASSWORD_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
            passwordStatus: 'sent',
        }
    },
    [type.GENERATE_NEW_PASSWORD_ERROR]: (state, action) => {
        return {
            ...state,
            fetching: false,
            passwordStatus: 'error',
        }
    },
    [type.SET_USER_VALIDATION_RESULT]: (state, action) => {
        const { validationMessageList } = action.payload
        return {
            ...state,
            validationMessageList,
        }
    },
    [type.CREATE_USER_REQUEST]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: true,
        }
    },
    [type.CREATE_USER_SUCCESS]: (state, action) => {
        const { currentUser } = action.payload
        return {
            ...state,
            currentUser,
            fetching: false,
        }
    },
    [type.CREATE_USER_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
        }
    },
    [type.FIND_ALL_ROLE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_ALL_ROLE_SUCCESS]: (state, action) => {
        const { roleList } = action.payload
        return {
            ...state,
            fetching: false,
            roleList,
        }
    },
    [type.FIND_ALL_ROLE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_CURRENT_ROLE_ID]: (state, action) => {
        const { currentRoleId } = action.payload
        const currentRole = state.roleList.find(role => {
            return role.id === currentRoleId
        })
        return {
            ...state,
            currentRoleId,
            currentRole,
            error: null,
        }
    },
    [type.TOGGLE_ROLE_WIDGET_ACCESS]: (state, action) => {
        const { widgetId, active } = action.payload
        const widgetList = !active ? state.currentRole.widgetList.filter(currentWidgetId => currentWidgetId !== widgetId) : [
            ...state.currentRole.widgetList,
            widgetId,
        ]
        return {
            ...state,
            hasChanged: true,
            currentRole: {
                ...state.currentRole,
                widgetList,
            },
        }
    },
    [type.SAVE_ROLE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_ROLE_SUCCESS]: (state, action) => {
        const { currentRole } = action.payload
        return {
            ...state,
            fetching: false,
            hasChanged: false,
            currentRole,
        }
    },
    [type.SAVE_ROLE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/security/state/manage/reducer.js